import {
  Box,
  Checkbox,
  FormControlLabel,
  Grid,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";

const Company = ({ formik, errorMessage, isUserAdmin, isCreatingAccount }) => {
  return (
    <Box component="form" sx={{ mt: 1 }}>
      <Grid container>
        <Grid item xs={12} sm={12} padding={2}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="companyName"
            label="Company"
            name="companyName"
            value={formik.values.companyName}
            onChange={formik.handleChange}
          />
          {formik.errors.companyName ? (
            <Typography color={"red"}>{formik.errors.companyName}</Typography>
          ) : null}
          <TextField
            margin="normal"
            fullWidth
            id="companyContactName"
            label="Company Contact Name"
            name="companyContactName"
            value={formik.values.companyContactName}
            onChange={formik.handleChange}
          />
          {formik.errors.companyContactName ? (
            <div>{formik.errors.companyContactName}</div>
          ) : null}
          <TextField
            margin="normal"
            fullWidth
            id="companyContactEmail"
            label="Company Contact Email"
            name="companyContactEmail"
            value={formik.values.companyContactEmail}
            onChange={formik.handleChange}
            autoComplete="email"
          />
          {formik.errors.companyContactEmail ? (
            <div>{formik.errors.companyContactEmail}</div>
          ) : null}
          <TextField
            margin="normal"
            fullWidth
            id="companyContactPhone"
            label="Company Contact Phone"
            name="companyContactPhone"
            value={formik.values.companyContactPhone}
            onChange={formik.handleChange}
            autoComplete="phone"
          />
          {formik.errors.companyContactPhone ? (
            <div>{formik.errors.companyContactPhone}</div>
          ) : null}

          {
            // Only EZORDER ADMIN can update Credit Type
            isUserAdmin && (
              <>
                <TextField
                  sx={{ marginTop: "16px" }}
                  select
                  variant="outlined"
                  label="Credit Type"
                  id="creditType"
                  name="creditType"
                  fullWidth
                  value={formik.values.creditType}
                  onChange={(e) => {
                    formik.setValues({
                      ...formik.values,
                      creditType: e.target.value,
                      creditTerms:
                        e.target.value == "Credit Terms" ? "Net 30" : null,
                    });
                  }}
                >
                  <MenuItem value={"Pay in Advance"}>Pay in Advance</MenuItem>
                  <MenuItem value={"Cash On Delivery"}>
                    Cash On Delivery
                  </MenuItem>
                  <MenuItem value={"Credit Terms"}>Credit Terms</MenuItem>
                </TextField>
                {formik.errors.creditType ? (
                  <div>{formik.errors.creditType}</div>
                ) : null}
              </>
            )
          }

          {
            // Only EZORDER ADMIN can update credit terms and only if Credit Terms is selected as Credit Type
            isUserAdmin && formik.values.creditType == "Credit Terms" && (
              <>
                <TextField
                  sx={{ marginTop: "16px" }}
                  select
                  variant="outlined"
                  label="Credit Terms"
                  id="creditTerms"
                  name="creditTerms"
                  fullWidth
                  value={formik.values.creditTerms}
                  onChange={(e) => {
                    formik.setValues({
                      ...formik.values,
                      creditTerms: e.target.value,
                    });
                  }}
                >
                  <MenuItem value={"Net 30"}>Net 30</MenuItem>
                  <MenuItem value={"Net 45"}>Net 45</MenuItem>
                  <MenuItem value={"Net 60"}>Net 60</MenuItem>
                </TextField>
                {formik.errors.creditTerms ? (
                  <div>{formik.errors.creditTerms}</div>
                ) : null}
              </>
            )
          }
          {
            // Can only select vendor type user if creating a new company
            isUserAdmin && isCreatingAccount && (
              <FormControlLabel
                sx={{ marginTop: "16px" }}
                control={
                  <Checkbox
                    checked={formik.values.isVendorOrSupplier}
                    onChange={(e) => {
                      formik.setValues({
                        ...formik.values,
                        isVendorOrSupplier: e.target.checked,
                      });
                    }}
                  />
                }
                label="Vendor / Supplier Ordering on Behalf of Others"
              />
            )
          }
        </Grid>
      </Grid>
      {errorMessage && (
        <Box>
          <Typography color={"red"}>{errorMessage}</Typography>
        </Box>
      )}
    </Box>
  );
};

export default Company;
